<template lang="pug">
.section
  .section-header
    template(v-if="mode == 0")
      h1 {{ $t("ui.total_mini_game_reward") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect(mode = mode-1)")
          i.fas.fa-arrow-left
      h1 {{ getPageName(mode) }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0);" @click="redirect(0)") {{ $t("ui.total_mini_game_reward") }}
        template(v-if="mode == 1")
          .breadcrumb-item.active
            span {{ getPageName(mode) }}
        template(v-else-if="mode == 2")
          .breadcrumb-item(v-if="!isOperator")
            a(href="javascript:void(0);" @click="redirect(1)") {{ $t("ui.total_mini_game_reward_detail") }}
          .breadcrumb-item.active
            span {{ getPageName(mode) }}

  .section-body
    .row
      .col-12
        template(v-if="mode == 0")
          .card.mb-0
            .card-header
              .row.w-100
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :disabled="loading" :placeholder="$t('message.search_by_operator')" @enter="getOperatorGameCoin(true)" size="sm")
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-gamepad
                    DebounceInput(autofocus type="text" v-model="searchGameName" :disabled="loading" :placeholder="$t('message.search_by_game_name')" @enter="getOperatorGameCoin(true)" size="sm")
                .form-group.col-md-12.col-lg-12.col-xl-5.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getOperatorGameCoin(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="5%")
                            span #
                          th(width="10%") {{ $t('ui.game_type') }}
                          th(width="15%") {{ $t('ui.game_name') }}
                          th.text-right(width="10%")
                            span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                          th.text-right(width="10%") {{ $t('ui.total_reward') }}
                      tbody
                        tr(v-if="gameRequestList.length == 0")
                          td(colspan="5").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for='(item, index) in gameRequestList')
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.game_type.toUpperCase()") {{ item.game_type.toUpperCase() }}
                          td
                            span(:title="item.game_name") {{ item.game_name }}
                          td.text-right
                            span(:title="$moment(item.created_dt).format('YYYY-MM-DD')") {{ $moment(item.created_dt).format('YYYY-MM-DD') }}
                          td.text-right
                            b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="$n(item.total_reward, 'currency')" @click="pageMode(item, 1)") {{ $n(item.total_reward, 'currency') }}

        template(v-if="mode == 1")
          totalMiniGameRewardDetail(ref="totalMiniGameRewardDetail" :id="selectedOperatorID" :date="workingDate" :gameId="selectedGameId" :gameName="selectedGameName" @clicked="pageMode")
        template(v-else-if="mode == 2")
          totalMiniGameRewardDetailOperator(ref="totalMiniGameRewardDetailOperator" :id="selectedOperatorID" :date="workingDate" :gameId="selectedGameId" :gameName="selectedGameName" @clicked="pageMode")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import totalMiniGameRewardDetail from "@/views/report/_totalMiniGameRewardDetail.vue";
import totalMiniGameRewardDetailOperator from "@/views/report/_totalMiniGameRewardDetailOperator.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    totalMiniGameRewardDetail,
    totalMiniGameRewardDetailOperator
  },
  data: () => ({
    loading: false,
    selectedOperatorID: null,
    workingDate: null,
    selectedDate: {
      startDate: null,
      endDate: null
    },
    gameRequestList: [],
    currentPage: 1,
    totalRow: 0,
    searchID: "",
    selectedGameId: "",
    selectedGameName: "",
    searchGameName: "",
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    mode: 0, // 0 = totalminigamereward , 1 = totalminigamerewarddetail, 2 = totalminigamerewarddetailoperator
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    }
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }
      }
      if (this.$store.getters.reportStatement.game_name) {
          this.searchGameName = this.$store.getters.reportStatement.game_name;
        }
      this.getOperatorGameCoin(true);
    }
  },
  methods: {
    redirect(mode) {
      if(mode == 1 && this.isOperator) {
        mode = 0;
      }
      this.mode = mode

      if(this.mode == 1) {
        var vm = this

        $(document).ready(function(){
          vm.$refs.totalMiniGameRewardDetail.getList()
        });
      } else {
        this.selectedOperatorID = null;
        this.getOperatorGameCoin(true);
      }
    },
    getPageName(mode) {
      switch(mode){
        case 1:
          return this.$t('ui.total_mini_game_reward_detail')
        case 2:
          return this.$t('ui.total_mini_game_reward_detail_operator')
      }
    },
    pageMode(data, e) {
      if(e == 2)
        this.selectedOperatorID = data.operator_id
      this.selectedDate.startDate = this.dateRange.startDate
      this.selectedDate.endDate = this.dateRange.endDate
      this.workingDate = data.created_dt
      this.selectedGameId = data.game_id
      this.selectedGameName = data.game_type.toUpperCase() + ' - ' + data.game_name
      if(data.working_date != null) {
        this.selectedDate.startDate = data.created_dt
        this.selectedDate.endDate = data.created_dt
      }
      if(this.isOperator && e == 1) {
        this.selectedOperatorID = this.accountID
        e = 2;
      }
      this.mode = e
      var vm = this

      $(document).ready(function(){
        switch(e) {
          case 1:
            if(!this.isOperator)
              vm.$refs.totalMiniGameRewardDetail.getList(true, true)
            else
              vm.$refs.totalMiniGameRewardDetailOperator.getList(true, true)
            break
          case 2:
            vm.$refs.totalMiniGameRewardDetailOperator.getList(true, true)
            break
        }
      });
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getOperatorGameCoin(true);
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        game_name: this.searchGameName,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getOperatorGameCoin: function(isSearch) {
      if (this.checkDateRange()) {
        this.setReportStatementParam();
        let url = config.getOperatorGameAmountUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          game_name: this.searchGameName,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.gameRequestList = response.data.dt;
                  this.totalRow = this.gameRequestList.length > 0 ? this.gameRequestList[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.gameRequestList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getOperatorGameCoin(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getOperatorGameCoin();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>